import $ from 'jquery'
import jsrender from 'jsrender'
jsrender($)

function handleAjaxError(jqXHR, textStatus, errorThrown) {
  console.error('Failed to load data:', textStatus, errorThrown)
  $('#result').html('<div class="error-message"><p>Unable to load information. Please try again.</p></div>')
}

function renderTemplate(data) {
  const templateEl = document.getElementById('theTmpl')
  if (!templateEl) {
    console.error('Template #theTmpl not found in DOM')
    $('#result').html('<div class="error-message"><p>Template not found.</p></div>')
    return false
  }
  $.views.settings.delimiters('[%', '%]')
  const template = $.templates('#theTmpl')
  const htmlOutput = template.render(data)
  $('#result').html(htmlOutput)
  return true
}

function initMap (data) {
  if (typeof google === 'undefined' || !google.maps) {
    console.error('Google Maps API not loaded')
    $('#location-map').html(
      '<p class="map-error">Map unavailable. <a href="https://maps.google.com/?q=' +
      encodeURIComponent(data.lat + ',' + data.lng) +
      '" target="_blank">View in Google Maps</a></p>'
    )
    return
  }

  const latLng = { lat: parseFloat(data.lat), lng: parseFloat(data.lng) }
  const map = new google.maps.Map(document.getElementById('location-map'), {
    zoom: 18,
    center: latLng
  })

  const marker = new google.maps.Marker({
    position: latLng,
    map: map,
    title: data.title
  })
}

$(document).on('click', '.element-locations', function (e) {
  e.preventDefault()
  const id = $(this).data('id')
  const placeAPI = '/api/locations/' + id + '.json'
  $('body').addClass('frozen')
  $('#location-info-wrapper').addClass('active').find('.close-button').focus()
  setTimeout(function () {
    $('#location-info-wrapper').addClass('transitioned')
  }, 10)
  $.getJSON(placeAPI)
    .done(function (data) {
      if (renderTemplate(data) && data.lat && data.lng) {
        initMap(data)
      }
    })
    .fail(handleAjaxError)
})

$(document).on('click', '.element-staff', function (e) {
  e.preventDefault()
  const id = $(this).data('id')
  const placeAPI = '/api/people/' + id + '.json'
  $('body').addClass('frozen')
  $('#location-info-wrapper').addClass('active').find('.close-button').focus()
  setTimeout(function () {
    $('#location-info-wrapper').addClass('transitioned')
  }, 10)
  $.getJSON(placeAPI)
    .done(function (data) {
      renderTemplate(data)
    })
    .fail(handleAjaxError)
})

$(document).on('click', 'a[href$="#membershipTable"]', function (e) {
  e.preventDefault()
  const id = $(this).data('id')
  $('body').addClass('frozen')
  $('#location-info-wrapper').addClass('active wide').find('.close-button').focus()
  setTimeout(function () {
    $('#location-info-wrapper').addClass('transitioned')
  }, 10)
  $.getJSON('/resources/membershipTable.json')
    .done(function (data) {
      renderTemplate(data)
    })
    .fail(handleAjaxError)
})

function closeWrapper () {
  $('#location-info-wrapper').removeClass('transitioned')
  setTimeout(function () {
    $('body').removeClass('frozen')
    $('#location-info-wrapper').removeClass('active')
  }, 350)
}

$(document).on('click', '#location-info-wrapper .close-button', function () {
  closeWrapper()
})

$(document).keyup(function (e) {
  if (e.keyCode === 27) { // escape key maps to keycode `27`
    closeWrapper()
  }
})
